module.exports = __webpack_public_path__ + "img/item-shields-04.13949311.png";